import React from "react";
import "./../styles/variable-projects.css";
import Projectsvariable from "../components/variable-projects";
import imagem1 from '../assets/images/Projetos/Estúdios/estudio-televisão.jpg';
import imagem2 from '../assets/images/Projetos/Estúdios/estudiotv.png';
import imagem3 from '../assets/images/Projetos/Estúdios/estúdio-img3.png';


const App = () => {
  const projectData = {
    date: "26/03/2018",
    title: "Estúdio de Televisão",
    images: [
      imagem1,
      imagem2,
      imagem3
    ],
    description:
      "Atuamos com estúdios renomados, como o estúdio do MasterChef da Band e Jornal Nacional da Rede Globo, fornecendo as soluções:",
    solutions: ["Cabeamento para Estúdio", "Configuração de Equipamentos", "Suporte Técnico"],
  };

  return <Projectsvariable {...projectData} />;
};

export default App;